import React, {Component} from 'react';

import { Carousel } from '../../../shared/components/carousel';
import CarouselIndicator from '../../../shared/components/carousel-indicator';
import NavArrow from '../../../shared/components/nav-arrow';
import ContentCarouselCard from './content-carousel-card';
import withWindowResize from '../../../ui/components/window-resize';


class ContentCarousel extends Component {

  constructor(props) {
    super(props);
    this.state = {
      relatedBlogs: [],
    }
  }



  static getDerivedStateFromProps(nextProps, prevState) {

    if(typeof nextProps.relatedBlogs === "object" && Object.keys(nextProps.relatedBlogs).length) {
      const {hits} = nextProps.relatedBlogs.hits;
      const relatedBlogs = hits.reduce((acc, hit) => {
        const {blogThumbnail, blogTitle, vanityUrl} = hit["_source"];
        const blog = {blogThumbnail, blogTitle, vanityUrl};
        acc.push(blog);
        return acc;
      }, []);

      return {
        relatedBlogs,
      }

    }

    return null;
  }

  getSlideConfig = () => {
    let {customBreakpoints} = this.props;
    let {relatedBlogs} = this.state;
    let customSlideCount, slidesToShow;
    let length = relatedBlogs && relatedBlogs.length;
    let stellarGrid = customBreakpoints && customBreakpoints['stellar-grid'];
    switch(stellarGrid){
      case 'xlarge':
        customSlideCount = length > 5 ? length - 5 : length // extra large - 6.5 per slide
        slidesToShow = 5;
        break;
      case 'large':
        customSlideCount = length > 4 ? length - 4 : length // large - 5 per slide
        slidesToShow = 4;
        break;
      case 'medium':
        customSlideCount = length > 3 ? length - 3 : length // medium - 4 per slide
        slidesToShow = 3;
        break;
      case 'small':
        customSlideCount = length > 2 ? length - 1 : length // small - 3 per slide
        slidesToShow = 2;
        break;
      case 'xsmall':
        customSlideCount = length;// extra small - 1 per slide
        slidesToShow=1;
    }

    return {
      customSlideCount,
      slidesToShow
    }
  }

  controls = () => {
    let { customSlideCount } = this.getSlideConfig();
    return {
        renderCenterLeftControls : NavArrow.PrevArrow,
        renderCenterRightControls: (props) => <NavArrow.NextArrow {...props} customSlideCount={customSlideCount} />,
        renderBottomCenterControls: (props) => <CarouselIndicator {...props} customSlideCount={customSlideCount} /> 
    }
  }

  render() {

    const {relatedBlogs} = this.state;
    const {header=null, device} = this.props;
    let slideConfig = this.getSlideConfig();

    let sliderDimensionsProps = {
                                  slideWidth: "258px",
                                  initialSlideHeight: "380px"
                                };
 
    return (
      <div className="content-carousel-container">
      {
        header && <h3>{header}</h3>
      }
      <div className={`content-carousel-${device}-component`}>
        {
            <Carousel {...sliderDimensionsProps} renderBottomCenterControls={false} id='content-carousel-richtext' className='content-carousel-richtext' {...this.controls()} {...slideConfig} ref={carousel=> carousel = carousel}>
              {
                relatedBlogs.map((relatedBlog, i) => {
                  const {blogThumbnail, blogTitle, vanityUrl} = relatedBlog;
                  return (
                    <ContentCarouselCard thumbnail={blogThumbnail} title={blogTitle} vanityUrl={vanityUrl} key={i}/>
                  )
                })
              }
            </Carousel>
        }
        </div>
      </div>
    );
  }
}

export default withWindowResize(ContentCarousel);
